import styled from 'styled-components';
import BackButton from '../utils/back_button';
import { student_blog3 } from "../../../assets/images";
import { useNavigate } from 'react-router-dom';
import OtherBlogs from '../our_blogs/OtherBlogs';
import CTASection from "../../landing/landing_home/empower";

export default function Blog20() {

  return (
    <>
     <Fullpage>
      <PageBackground>
        <BlogContainer>
          <BlogWrapper>
            <BlogHeader
              title="Saving Time with an LXP Student Portal"
              date="09 January 2026"
              author="posted by campus insights"
              
            />
            <BlogContent />
          </BlogWrapper>
        </BlogContainer>
        <OtherBlogs currentBlogId={20} type="ai-lms-students" />
     </PageBackground>
     
     </Fullpage>
     <CTASection />
    
    </>
  );
};

const BlogHeader = ({ title, date, author}) => {
   const navigate = useNavigate();
  const handleBackClick = () => {
     window.scrollTo(0, 0);
     navigate("/blog")
  };
  return (
    <HeaderContainer>
      <HeaderContent>
        <BackButtonWrapper>
          <BackButton onClick={ handleBackClick} />
        </BackButtonWrapper>
        <MainTitle>{title}</MainTitle>
        <MetadataContainer>
          <MetadataWrapper>
            <MetadataContent>
              <DateText>{date}</DateText>
              <AuthorText>{author}</AuthorText>
            </MetadataContent>
          </MetadataWrapper>
        </MetadataContainer>
      </HeaderContent>
      <HeroImage src={student_blog3}  />
      <IntroText>
        For students, time is often the most precious resource. Between classes, assignments, part‑time jobs, and personal commitments, it can feel like there’s never enough of it. That’s where an AI‑powered Learning Management System (LMS) Student Portal makes a real difference—it doesn’t just help you learn, it helps you save time while doing it.
      </IntroText>
    </HeaderContainer>
  );
};

const BlogContent = () => {
  return (
    <ContentContainer>
      <BlogSection>
        <ContentText>
          One of the biggest time‑savers is personalized learning paths. Instead of sifting through endless materials, the portal uses AI to recommend exactly what you need. That means less time wasted on irrelevant content and more time focused on mastering the topics that matter most to you
        </ContentText>
        <ContentText>
          Another advantage is instant feedback. Traditionally, students wait days or even weeks to know how they performed on assignments or tests. With AI, results are available immediately. You can correct mistakes right away, move forward faster, and avoid the frustration of waiting in limbo.
        </ContentText>
        <ContentText>
          The portal also streamlines organization and scheduling. Built‑in reminders, progress trackers, and smart notifications keep you on top of deadlines without the need for manual planners. This reduces the risk of last‑minute scrambles and helps you manage your study time more effectively.
        </ContentText>
        <ContentText>
          And let’s not forget 24/7 accessibility. Whether you’re an early riser or a night owl, the LXP (Learning eXperience Platform) Student Portal is always available. You don’t have to adjust your schedule to office hours or wait for a teacher’s response—you can learn whenever it fits into your day.
        </ContentText>
        <ContentText>
          By cutting down on wasted effort, reducing delays, and offering flexible access, the LXP Student Portal gives students back one of the most valuable things they need: time. And with that extra time, you can focus on deeper learning, personal growth, or simply finding balance in your busy life.
        </ContentText>
      </BlogSection>
    </ContentContainer>
  );
};

const BlogSection = ({ title, children, ismainsection = "false" }) => {
  return (
    <SectionContainer>
      {title && (
        <SectionTitle ismainsection={ismainsection}>
          {title}
        </SectionTitle>
      )}
      <SectionContent>
        {children}
      </SectionContent>
    </SectionContainer>
  );
};

const SubSection = ({ title, children, image, imageAlt }) => {
  return (
    <SubSectionContainer>
      {image && (
        <SubSectionImage src={image} alt={imageAlt} />
      )}
      {title && (
        <SubSectionTitle>{title}</SubSectionTitle>
      )}
      <SubSectionText>{children}</SubSectionText>
    </SubSectionContainer>
  );
};

const SubSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const SubSectionImage = styled.img`
  width: 763px;
  height: 400px;
  border-radius: 16px;
  max-width: 100%;
  object-fit: cover;
  @media (max-width: 991px) {
    width: 100%;
    height: 300px;
  }
  @media (max-width: 640px) {
    height: 240px;
  }
`;

const SubSectionTitle = styled.h3`
  color: #64636a;
  letter-spacing: -0.2px;
  font: 500 20px/140% Inter, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 18px;
  }
`;

const SubSectionText = styled.p`
  align-self: stretch;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 500 16px/160% Inter, sans-serif;
  margin: 0;
`;


const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

const SectionTitle = styled.h2`
  align-self: stretch;
  color: ${props => props.ismainsection ? '#1c1b1f' : '#64636a'};
  letter-spacing: ${props => props.ismainsection ? '-0.32px' : '-0.2px'};
  font: ${props => props.ismainsection ? '700 32px/120% Inter, sans-serif' : '500 20px/140% Inter, sans-serif'};
  margin: 0;
  @media (max-width: 640px) {
    font-size: ${props => props.ismainsection ? '24px' : '18px'};
  }
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 42px;
  align-self: stretch;
`;

const ContentText = styled.p`
  align-self: stretch;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 500 16px/160% Inter, sans-serif;
  margin: 0;
`;


const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  `;

const BackButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

const MainTitle = styled.h1`
  width: 100%;
  color: #1c1b1f;
  letter-spacing: -0.48px;
 
  font: 700 48px/120% Inter, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 36px;
    line-height: 120%;
  }
  @media (max-width: 640px) {
    font-size: 28px;
    line-height: 120%;
  }
`;

const MetadataContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

const MetadataWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
`;

const MetadataContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const DateText = styled.time`
  color: #64636a;
  letter-spacing: 2px;
  text-transform: uppercase;
  font: 400 16px/120% Inter, sans-serif;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const AuthorText = styled.span`
  color: #64636a;
  letter-spacing: 2px;
  text-transform: uppercase;
  font: 500 16px/120% Inter, sans-serif;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const HeroImage = styled.img`
  display: flex;
  width: 100%;
  height: 346px;
  justify-content: flex-end;
  align-items: center;
  border-radius: 16px;
  object-fit: cover;
  @media (max-width: 991px) {
    height: 280px;
  }
  @media (max-width: 640px) {
    height: 200px;
  }
`;

const IntroText = styled.p`
  align-self: stretch;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 500 16px/160% Inter, sans-serif;
  margin: 0;
`;


const BlogContainer = styled.article`
  display: flex;
  width: 1120px;
  padding: 56px;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  border-radius: 24px;
  margin: 0 auto;
  max-width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  @media (max-width: 991px) {
    width: 100%;
    padding: 40px 32px;
    gap: 48px;
  }
  @media (max-width: 640px) {
    padding: 24px 16px;
    gap: 32px;
  }
`;

const BlogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 42px;
  align-self: stretch;
`;

const PageBackground = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 500px, #F5F5F9 100px, #F5F5F9 100%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 200px 0;
    flex-direction: column;

  @media (max-width: 640px) {
    padding: 40px 0;
    background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 100px, #ffffff 100px, #ffffff 100%);
  }
`;

const Fullpage = styled.div`
  height: 100%;
  width: 100%;
//   background-color: #e20707ff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
 

  @media (max-width: 640px) {
    padding: 40px 0;
   
  }
`;
